export const secureConnectionStatus = {
  reviewFrontline: 'review_frontline',
  resolvedFrontline: 'resolved_frontline',
}
